<template>
  <div
    class="report-display"
    :style="{ height: tableShow ? 'auto' : '0px' }"
  >
    <main class="table-padding">
      <div class="table-col-name">
        <h3 class="first-col">
          {{lang['components']['Report']['Charts']['MaterialChartReport']['label_a']}}
        </h3>
        <h3>
          {{lang['components']['Report']['Charts']['MaterialChartReport']['label_b']}}
        </h3>
      </div>
      <div class="table-col-value" v-for="(item, idx) in tableData[listKey]" :key="idx">
        <!-- <p class="first-col">
          {{ item.since }} ～ {{ item.until }}
        </p>
        <p>
          {{ item.title }}
        </p> -->
        <p class="first-col">
          {{ item.date }}
        </p>
        <p>
          {{ item.describe }}
        </p>
      </div>
    </main>
  </div>
</template>

<script>

// import { ref } from 'vue';

export default {
  name: 'MaterialChartReport',
  props: {
    tableShow: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => []
    },
    listKey: {
      type: String,
      default: ''
    },
    lang: {
      type: Object
    }
  },
  watch:{
    listKey(value){
      //console.log('listKey:'+value);
      //console.log(this.tableData);
    },
  }
};
</script>

<style lang="scss" scoped>

.report-display {
  width: 100%;
  height: 0px;
  overflow: hidden;
  transition: 0.6s;
}

.table-padding {
  padding: 35px;
}

.table-col-name {
  display: flex;
  height: 24.15px;
  border-bottom: 1px solid #9B9B9B;

  .first-col {
    width: 10%;
  }

  h3 {
    font-family: PingFang HK;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }
}

.table-col-value {
  display: flex;
  height: 49.58px;
  padding-top: 7.26px;
  border-bottom: 1px solid #F7F7F7;

  .first-col {
    width: 10%;
  }

  p {
    font-family: PingFang HK;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 17px;
    color: #7E7E7E;
  }
}

</style>